/** Luxistt WhatsApp (international, no + for wa.me) */
export const WHATSAPP_E164_DIGITS = '2349160010451';

export const WHATSAPP_DISPLAY = '+234 916 001 0451';

/** Opens WhatsApp chat with optional prefilled message */
export const getWhatsAppChatUrl = (message = 'Hello Luxistt, I would like to know more about booking an apartment.') => {
  const q = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_E164_DIGITS}?text=${q}`;
};
